import { Radio, Space } from 'antd';
import { v4 as uuid } from 'uuid';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import { BUTTON_VARIANT_DARK } from '../../../../../../components/forms/ZorbaButton/constants';
import { ZorbaButton } from '../../../../../../components/forms';
import MultiPlacesAutoComplete from '../../../../../../components/forms/MultiPlacesAutoComplete';
import { setAppliedFilters } from '../../../../../../reducers/Filters/actions';

import { options } from '../constants';

import '../index.scss';

export const CityCountyZipBuilder = ({ onApplyFilter }) => {
  const dispatch = useDispatch();
  const { appliedFilters } = useSelector(
    ({ FiltersReducer }) => FiltersReducer,
  );
  const { userDetails } = useSelector(({ AuthReducer }) => AuthReducer);
  const [defaultRadioValue] = Object.keys(appliedFilters.cityCountyZip ?? {});
  const defaultSelectValue = defaultRadioValue
    ? appliedFilters.cityCountyZip[defaultRadioValue]
    : [];

  const [radioValue, setRadioValue] = useState(defaultRadioValue);
  const [selectedPlaces, setSelectedPlaces] = useState(defaultSelectValue);
  const handleRadioChange = (event) => {
    setRadioValue(event.target.value);
  };

  const onPlacesChange = (address) => {
    if (!address) return;

    const updatedAreaList = _.uniqBy([...address], 'googlePlaceId');
    setSelectedPlaces(updatedAreaList);
  };

  const isApplyButtonDisabled = !radioValue || !selectedPlaces.length;
  const handleApply = () => {
    dispatch(
      setAppliedFilters('cityCountyZip', {
        [radioValue]: selectedPlaces,
      }),
    );
    onApplyFilter();
  };

  const connectedStates =
    userDetails?.defaultOrganization?.dataSubscription?.activatedStates || [];
  const hasNationwideAccess =
    userDetails?.defaultOrganization?.dataSubscription?.hasNationwideAccess;

  return (
    <div className="builder-container">
      <h3>State</h3>
      <div className="options-container">
        <Radio.Group onChange={handleRadioChange} value={radioValue}>
          <Space direction="vertical">
            {options.map((option) => (
              <Radio key={uuid()} value={option.value}>
                {option.label}
              </Radio>
            ))}
          </Space>
        </Radio.Group>
        {radioValue && (
          <div style={{ marginTop: '10px' }}>
            <MultiPlacesAutoComplete
              hasNationwideAccess={hasNationwideAccess}
              activatedStates={connectedStates}
              onChange={(address) => onPlacesChange(address)}
              value={selectedPlaces}
              showOnlyLocalitiesCountiesAndZipCodes
            />
          </div>
        )}
      </div>
      <ZorbaButton
        variant={BUTTON_VARIANT_DARK}
        disabled={isApplyButtonDisabled}
        onClick={handleApply}
        fullWidth={false}
      >
        Apply
      </ZorbaButton>
    </div>
  );
};
